import * as React from 'react';
import { IgcCarouselIndicatorComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * Used when a custom indicator needs to be passed to the `igc-carousel` component.
 * @slot  - Default slot for projected inactive indicator.
 * @slot active - Default slot for projected active indicator.
 * @csspart indicator - The wrapping container of the carousel dot indicator.
 * @csspart inactive - The wrapping container of the inactive dot indicator.
 * @csspart active - The wrapping container of the active dot indicator.
 * @class
 */
export const IgrCarouselIndicator = /* @__PURE__ */ createComponent({
  tagName: 'igc-carousel-indicator',
  displayName: 'IgrCarouselIndicator',
  elementClass: Component,
  react: React,
});

export type IgrCarouselIndicator = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrCarouselIndicatorModule = Component;
